import { createSlice } from "@reduxjs/toolkit";

const InspecieTransferSlice = createSlice({
  name: "InspecieTransfer",
  initialState: {
    hinNumber: "",
    isFetch: false,
    isFetchExist: false,
    isFetchStrategy: false,
    isMatchFound: true,
    manualEntryVisible: false,
    manualStockList: [],
    portfolioList: [],
    stockList: [],
    requestId: null,
    file: null,
    investmentId: localStorage.getItem("investmentId") || null,
    tabSelf:"view"
  },
  reducers: {
    setHinNumberRedux: (state, action) => {
      //localStorage.setItem("hinNumber", action.payload);
      state.hinNumber = action.payload;
    },
    clearHinNumber: (state) => {
      //localStorage.removeItem("hinNumber");
      state.hinNumber = "";
    },
    setIsFetchRedux: (state, action) => {
      //   localStorage.setItem("isFetch", action.payload);
      state.isFetch = action.payload;
    },
    clearIsFetch: (state) => {
      //   localStorage.removeItem("isFetch");
      state.isFetch = false;
    },
    setIsFetchExistRedux: (state, action) => {
      //   localStorage.setItem("isFetchExist", action.payload);
      state.isFetchExist = action.payload;
    },
    clearIsFetchExist: (state) => {
      //   localStorage.removeItem("isFetchExist");
      state.isFetchExist = false;
    },
    setIsFetchStrategyRedux: (state, action) => {
      //   localStorage.setItem("isFetchStrategy", action.payload);
      state.isFetchStrategy = action.payload;
    },
    clearIsFetchStrategy: (state) => {
      //   localStorage.removeItem("isFetchStrategy");
      state.isFetchStrategy = false;
    },
    setIsMatchFoundRedux: (state, action) => {
      //   localStorage.setItem("isMatchFound", action.payload);
      state.isMatchFound = action.payload;
    },
    clearIsMatchFound: (state) => {
      //   localStorage.removeItem("isMatchFound");
      state.isMatchFound = false;
    },
    setManualEntryVisibleRedux: (state, action) => {
      //   localStorage.setItem("manualEntryVisible", action.payload);
      state.manualEntryVisible = action.payload;
    },
    clearManualEntryVisible: (state) => {
      //   localStorage.removeItem("manualEntryVisible");
      state.manualEntryVisible = false;
    },
    setManualStockListRedux: (state, action) => {
      //   localStorage.setItem("manualEntryVisible", action.payload);
      state.manualStockList = action.payload;
    },
    clearManualStockList: (state) => {
      //   localStorage.removeItem("manualEntryVisible");
      state.manualStockList = [];
    },
    setPortfolioListRedux: (state, action) => {
      //   localStorage.setItem("manualEntryVisible", action.payload);
      state.portfolioList = action.payload;
    },
    clearPortfolioList: (state) => {
      //   localStorage.removeItem("manualEntryVisible");
      state.portfolioList = [];
    },
    setStockListRedux: (state, action) => {
      //   localStorage.setItem("manualEntryVisible", action.payload);
      state.stockList = action.payload;
    },
    clearStockList: (state) => {
      //   localStorage.removeItem("manualEntryVisible");
      state.stockList = [];
    },
    setRequestIdRedux: (state, action) => {
      //   localStorage.setItem("manualEntryVisible", action.payload);
      state.requestId = action.payload;
    },
    clearRequestId: (state) => {
      //   localStorage.removeItem("manualEntryVisible");
      state.requestId = null;
    },
    setFileRedux: (state, action) => {
      //   localStorage.setItem("manualEntryVisible", action.payload);
      state.file = action.payload;
    },
    clearFile: (state) => {
      //   localStorage.removeItem("manualEntryVisible");
      state.file = null;
    },
    setInvestmentIDRedux: (state, action) => {
      localStorage.setItem("investmentId", action.payload);
      state.investmentId = action.payload;
    },
    clearInvestmentID: (state) => {
      localStorage.removeItem("investmentId");
      state.investmentId = null;
    },
        setTabSelfRedux: (state, action) => {
      //   localStorage.setItem("manualEntryVisible", action.payload);
      state.tabSelf = action.payload;
    },
    clearTabSelf: (state) => {
      //   localStorage.removeItem("manualEntryVisible");
      state.tabSelf = null;
    },
  },
});

export const {
  setHinNumberRedux,
  clearHinNumber,
  setIsFetchRedux,
  clearIsFetch,
  setIsFetchExistRedux,
  clearIsFetchExist,
  setIsFetchStrategyRedux,
  clearIsFetchStrategy,
  setIsMatchFoundRedux,
  clearIsMatchFound,
  setManualEntryVisibleRedux,
  clearManualEntryVisible,
  setManualStockListRedux,
  clearManualStockList,
  setPortfolioListRedux,
  clearPortfolioList,
  setStockListRedux,
  clearStockList,
  setRequestIdRedux,
  clearRequestId,
  setInvestmentIDRedux,
  clearInvestmentID,
  setTabSelfRedux,
  clearTabSelf
} = InspecieTransferSlice.actions;
export default InspecieTransferSlice.reducer;
